
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import SocialProofBanner from './components/SocialProofBanner';
import FeaturedSuccess from './components/FeaturedSuccess';
import CTASection from './components/CTASection';

const HomePage = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <ServicesOverview />
        </motion.div>
        <SocialProofBanner />
        <FeaturedSuccess />
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default HomePage;
